import React, { FunctionComponent, MouseEvent } from 'react'
import { withWidthLowerObserver } from '../../../../misc/WidthObserver.hoc'
import { breakSmall } from '../../../../misc/responsive'
import { DrugItemProps } from './DrugItem.model'
import { DrugThumbnail } from '../..'
import { ExternalResourceLink } from './ExternalResourceLink'
import { getVigilancePictogram } from '../../../../misc/drug.utilities'
import styles from './DrugItem.module.scss'

const DrugItem: FunctionComponent<DrugItemProps> = ({
  drug,
  treatment,
  isLowerThanBreakpoint,
  onMonographClick,
  onSMRClick,
}) => {
  const handleMonographClick = (event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    onMonographClick()
  }

  const handleSMRClick = (event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    onSMRClick()
  }

  const vigilancePictogram = getVigilancePictogram(drug.vigilanceLevel)

  return (
    <div className={styles.drugItemContainer}>
      <div className={styles.drugItemSummary}>
        <DrugThumbnail drug={drug} treatment={treatment} size="medium" />
      </div>
      <div className={styles.drugItemPictoWithSmrAndMonograph}>
        {vigilancePictogram && (
          <img
            className={styles.drugItemPicto}
            src={vigilancePictogram.pictogram}
            alt={vigilancePictogram.tooltip}
            title={vigilancePictogram.tooltip}
          />
        )}
        {drug.hasSmr && (
          <ExternalResourceLink
            label="SMR"
            shrink={isLowerThanBreakpoint}
            onClick={handleSMRClick}
          />
        )}
        {drug.hasMonograph && (
          <ExternalResourceLink
            label="Monographie"
            shrink={isLowerThanBreakpoint}
            onClick={handleMonographClick}
          />
        )}
      </div>
    </div>
  )
}

export default withWidthLowerObserver(breakSmall)(DrugItem)
